module.exports = __webpack_public_path__ + "img/gsb-bank46x46.6dd8279b.jpg";